import { newE2EPage } from "@stencil/core/testing";
import { testValidHtmlElement } from "../../../test-utils/html-validate";

const testCode = `
<!DOCTYPE html>
<html lang="en">
<head>
    <meta charset="utf-8" />
    <title>Page Title</title>
    <link rel="icon" href="assets/favicon.png" />
    <link rel="stylesheet" href="assets/style.css" />
</head>
<body class="demo">
    <!-- Comment -->
</body>
</html>
`;

describe("code", () => {
    it("should apply syntax highlighting", async () => {
        const page = await newE2EPage();
        await page.setContent(`<ux-code></ux-code>`);
        const el = await page.find("ux-code");
        el.setProperty("code", testCode);
        await page.waitForChanges();
        await testValidHtmlElement(el);
        expect(el).toMatchSnapshot();
    });

    it("should render differently in inline mode", async () => {
        const page = await newE2EPage();
        await page.setContent(`<ux-code inline></ux-code>`);
        const el = await page.find("ux-code");
        el.setProperty("code", `inline test code`);
        await page.waitForTimeout(500);
        await page.waitForChanges();
        await testValidHtmlElement(el);
        expect(el).toMatchSnapshot();
    });
});
